__turbopack_context__.v({
  "aside": "AppCard-module__-qFzTa__aside",
  "card": "AppCard-module__-qFzTa__card",
  "header": "AppCard-module__-qFzTa__header",
  "title": "AppCard-module__-qFzTa__title",
});
